function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var wt = /*#__PURE__*/function () {
  function wt(t, s, i, h, l) {
    _classCallCheck(this, wt);

    this.triggerId = t, this.Xr = s, this.$r = i, this.Hr = h, this.Jr = l, this.triggerId = t, this.Xr = s, this.$r = i, this.Hr = h, this.Jr = l;
  }

  _createClass(wt, null, [{
    key: "fromJson",
    value: function fromJson(t, s, i, h, l) {
      return null == t || null == t.trigger_id ? null : new wt(t.trigger_id, s, i, h, l);
    }
  }]);

  return wt;
}();

export { wt as default };